import MainLaundromats from "./MainLaundromats";
import Footer from "../Footer/Footer.js";

const LaundromatsWebPage = () => {
  return (
    <div
      style={{
        minHeight: "88vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <MainLaundromats />
      <Footer />
    </div>
  );
};

export default LaundromatsWebPage;
